<template>
  <div class="center-profile">
    <headers></headers>
    <div class="profile-con">
      <div class="content">
        <p>中国国际贸易促进委员会/中国国际商会调解中心及其各分会的调解中心，是以调解的方式，独立、公正的帮助中外当事人解决商事、海事等争议的常设调解机构。</p>
        <p>本中心成立于1987年，自成立以来顺应中国的改革开放和完善社会主义市场经济的需要，不断发展壮大。</p> 
        <p>截至2021年9月，已在全国各省、市、自治区及一些重要城市设立分会调解中心共59家，形成了庞大的调解网络。</p> 
      </div>
    </div>
  </div>
</template>

<script>
import headers from "@/components/header";
export default {
  name: "centerProfile",
  data() {
    return {
    };
  },
  components: {
    headers,
  },
  watch: {
  },
  methods: {
  },
  mounted() {

  },
  updated(){
  },
};
</script>

<style scoped lang="scss">
.center-profile{
  padding-top: 50px;
  box-sizing: border-box;
  height: 100%;
  .header{
    margin-top: -50px;
  }
  .profile-con{
    display: flex;
    justify-content: center;
    position: relative;
    height: 100%;
    background: url('./imgs/intro.png') no-repeat;
    background-size: 100%;
    .content{
      width: 90%;
      position: absolute;
      top: 100px;
      bottom: 20px;
      background: #FFFFFF;
      box-shadow: 0px 10px 40px 0px rgba(223, 223, 223, 0.91);
      border-radius: 16px; 
      padding: 20px 15px 50px;  
      box-sizing: border-box;
      font-weight: 400;
      color: #333333;
      line-height: 30px;
      font-size: 14px;
      p{
        text-indent: 20px;    
      }
    } 
  }
}
</style>
